import {
  ACTIVITY,
  CARD,
  TOMO_IQ,
  DASHBOARD,
  MORE,
  PAYMENTS,
  REFERRALS,
  // REWARDS,
  SETTINGS,
  STATEMENTS,
  SUPPORT,
  CREDIT_MONITORING,
  TOMO_BOOST,
  TOMO_ISSUING,
  SUPPORTAL,
} from "routes/pageConfig";

export const NUM_MOBILE_NAV_ITEMS = 4; // not including 'more'

// order matters!
export const NAV_BAR_ITEMS = [
  DASHBOARD,
  TOMO_BOOST,
  TOMO_IQ,
  CREDIT_MONITORING,
  TOMO_ISSUING,
  CARD,
  PAYMENTS,
  ACTIVITY,
  REFERRALS,
  // REWARDS,
  STATEMENTS,
  SETTINGS,
  MORE,
  SUPPORT,
  SUPPORTAL,
];

export const NAVBAR_BACKGROUND = 'linear-gradient(#030E0E 0%, rgb(0, 0, 0) 100%)';
